<template>
  <section>
    <img
      class="mute-button"
      :src="isMuted ? 'images/muted.svg' : 'images/unmuted.svg'"
      alt="Mute Button"
      @click="toggleMute"
    />
  </section>
</template>

<script>
export default {
  name: "MuteButton",
  data() {
    return {
      isMuted: false,
    };
  },
  methods: {
    toggleMute() {
      this.isMuted = !this.isMuted;
      const musicPlayer = document.getElementById("musicPlayer");
      if (musicPlayer) {
        musicPlayer.muted = this.isMuted;
      }
    },
  },
};
</script>

<style>
.mute-button {
  cursor: pointer; /* Change cursor to pointer on hover to indicate interactivity */
  position: fixed;
  top: 20px; /* Adjust the top position as needed */
  right: 20px; /* Adjust the right position as needed */
  z-index: 999; /* Ensure it's above other content */
  height: 50px;
}
</style>
